import { render, staticRenderFns } from "./LiveChatView.vue?vue&type=template&id=2a7b2d51&scoped=true"
import script from "./LiveChatView.vue?vue&type=script&lang=js"
export * from "./LiveChatView.vue?vue&type=script&lang=js"
import style0 from "./LiveChatView.vue?vue&type=style&index=0&id=2a7b2d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b2d51",
  null
  
)

export default component.exports